import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi";
function loadVuetifyTheme(themeType) {
  const baseThemeConfig = {
    defaultTheme: "customTheme",
    themes: {
      customTheme: {
        colors: {
          surface: "#FFFFFF",
          error: "#eb333d"
        },
        variables: {
          "medium-emphasis-opacity": "1 !important",
          "field-padding-top": "4px"
        }
      }
    }
  };

  const themeMap = {
    Minimal: { file: "minimal", button: "buttonNewTheme" },

    Compact: { file: "compact", button: "buttonCompact" },
    Clean: {
      file: "clean/layout",
      button: "clean/button",
      main: "clean/main",

      defaults: {
        VTextField: { density: "default", variant: "underlined" }
      }
    },
    Minibar: {
      file: "minibar/layout",
      button: "minibar/button",
      main: "minibar/main",
      variables: {
        "medium-emphasis-opacity": "1 !important",
        "field-padding-top": "8px"
      }
    },
    MinimalProfile: {
      file: "minimalProfile/layout",
      button: "minimalProfile/button",
      main: "minimalProfile/main",
      defaults: { VTextField: { density: "default", variant: "outlined" } },
      variables: {
        "medium-emphasis-opacity": "1 !important",
        "field-padding-top": "8px"
      }
    },
    Sharp: {
      main: "sharp/index",
      button: "sharp/button",
      file: "sharp/layout"
    },
    Banner: {
      file: "minimalProfileBanner/layout",
      button: "minimalProfileBanner/button",
      main: "minimalProfileBanner/main",
      defaults: { VTextField: { density: "default", variant: "outlined" } },
      variables: {
        "medium-emphasis-opacity": "1 !important",
        "field-padding-top": "8px"
      }
    },
    "standard-v2": { file: "vuetify", button: "buttonV2" },
    Default: { file: "vuetify", button: "button" }
  };

  console.log(themeType);
  const selected = themeMap[themeType] || themeMap.Default;

  // Clone base theme
  const themeConfig =
    themeType === "Default"
      ? { defaultTheme: "light" }
      : {
          ...baseThemeConfig,
          themes: {
            customTheme: {
              ...baseThemeConfig.themes.customTheme,
              variables: {
                ...baseThemeConfig.themes.customTheme.variables,
                ...(selected.variables || {})
              }
            }
          }
        };

  const defaults =
    themeType === "Default"
      ? {
          VSelect: { density: "default", variant: "outlined" },
          VTextField: { density: "default", variant: "outlined" },
          VTextarea: { density: "default", variant: "outlined" }
        }
      : {
          // VTextField: { density: "default", variant: "underlined" },
          ...(selected.defaults || {})
        };

  // โหลดไฟล์ธีม
  loadTheme(selected.file);
  loadTheme(selected.button);
  if (selected.main) loadTheme(selected.main);

  // สร้าง Vuetify instance
  return createVuetify({
    theme: themeConfig,
    components,
    directives,
    defaults,
    icons: {
      defaultSet: "mdi",
      aliases,
      sets: { mdi }
    }
  });
}

function loadTheme(themeName) {
  try {
    const existingLink = document.getElementById(`theme-style-${themeName}`);
    if (existingLink) existingLink.remove(); // ลบของเก่า

    const link = document.createElement("link");
    link.id = `theme-style-${themeName}`;
    link.rel = "stylesheet";

    link.href = `/stylesheets/custom/${themeName}.css`;
    document.head.appendChild(link);
  } catch (error) {
    logger({
      response: {
        config: {
          url: "api/v1/Setting/theme",
          methods: "GET",
          data: null
        }
      },
      action: {
        action: "loadTheme",
        id: 3,
        note: "on load css minimal " + themeName
      }
    });
  }
}
export { loadVuetifyTheme, loadTheme };
